module.exports = __webpack_public_path__ + "img/img67.84b7aee4.svg";